import { ClassTableFrame } from '@features/class/components/ClassTableFrame'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/classes/$classId/gallery')({
    component: () => <ClassTableFrame galleryMode={true} />,
    staticData: {
        crumb: {
            label: 'Gallery'
        }
    }
})